<template>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M19 12.8702C19 12.4002 18.66 12.0202 18.2 11.8902C16.93 11.5402 16 10.3802 16 9.00018V4.00018H17C17.55 4.00018 18 3.55018 18 3.00018C18 2.45018 17.55 2.00018 17 2.00018H7C6.45 2.00018 6 2.45018 6 3.00018C6 3.55018 6.45 4.00018 7 4.00018H8V9.00018C8 10.3802 7.07 11.5402 5.8 11.8902C5.34 12.0202 5 12.4002 5 12.8702V13.0002C5 13.5502 5.45 14.0002 6 14.0002H10.98L11 21.0002C11 21.5502 11.45 22.0002 12 22.0002C12.55 22.0002 13 21.5502 13 21.0002L12.98 14.0002H18C18.55 14.0002 19 13.5502 19 13.0002V12.8702Z"
  />
</template>
